import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // reviewText
    failedContentChanged: 'Контент изменился во время проверки — отправьте снова.',
    failedCancelled: 'Заявку отменило снятие с публикации.',
    failedStalled: 'Проверка зависла и была прервана. Отправьте снова — лимит не расходуется.',
    failedDefault: 'Проверка не состоялась из-за сбоя. Отправьте снова — лимит не расходуется.',
    catGambling: 'Азартные игры',
    catScam: 'Мошенничество или пирамида',
    catGuaranteedIncome: 'Обещание гарантированного дохода',
    catAdult: 'Контент для взрослых',
    catDrugs: 'Наркотики',
    catViolence: 'Насилие или экстремизм',
    catHate: 'Разжигание ненависти',
    catPolitics: 'Политика',
    catThirdPartyPromo: 'Реклама сторонних сервисов',
    catPersonalData: 'Персональные данные',
    catManipulation: 'Попытка повлиять на проверку',
    catProviderSafety: 'Отклонено фильтром безопасности модели',
    catExternalImage: 'Картинка не из нашего хранилища',
    catImageUnavailable: 'Картинку не удалось загрузить',
    // reviewOutcome
    resubmitHint: 'Исправьте нарушения и выберите доступ ниже, чтобы отправить снова',
    retryHint: 'Выберите доступ ниже, чтобы отправить снова',
    updateResubmitHint: 'Исправьте нарушения и отправьте обновление снова',
    rejectedTitle: 'Проверка не пройдена',
    updateRejectedTitle: 'Обновление не прошло проверку',
    // reviewInProgress
    articleSaveRefused: 'Статья на проверке — правка не сохранена',
    courseSaveRefused: 'Курс на проверке — правка не сохранена',
    articleTranslateRefused: 'Статья на проверке — перевод недоступен',
    // violationRef
    fieldName: 'Название',
    fieldDescription: 'Описание',
    fieldText: 'Текст',
    fieldTitle: 'Заголовок',
    fieldQuestion: 'Вопрос',
    fieldLink: 'Ссылка',
    fieldContent: 'Содержимое',
    fieldAnswer: 'Ответ',
    fieldExplanation: 'Пояснение',
    fieldBanner: 'Баннер',
    fieldStyleReferences: 'Образцы стиля',
    partOption: 'Вариант ответа',
    partPair: 'Пара',
    partButton: 'Кнопка',
    partElement: 'Элемент',
    partTable: 'Ячейка таблицы',
    partBadge: 'Бейдж',
    // updateFailure / visibilityChange / draftUpdate
    updateFailed: 'Не удалось отправить обновление',
    noChanges: 'Нет изменений для отправки',
    waitForRun: (run: string) => `Дождитесь окончания запуска: ${run}`,
    accessFailed: 'Не удалось изменить доступ',
    catalogNotAllowed: 'Публикация в каталог вам недоступна',
    requestWithdrawn: 'Заявка отозвана',
    draftDiscarded: 'Правки отменены',
    draftDiscardFailed: 'Не удалось отменить правки',
  },
  en: {
    failedContentChanged: 'The content changed during review — submit again.',
    failedCancelled: 'The review request was cancelled because the item was unpublished.',
    failedStalled:
      'The review stalled and was stopped. Submit again — it won’t count toward your limit.',
    failedDefault:
      'The review couldn’t run due to a technical error. Submit again — it won’t count toward your limit.',
    catGambling: 'Gambling',
    catScam: 'Scam or pyramid scheme',
    catGuaranteedIncome: 'Guaranteed income claims',
    catAdult: 'Adult content',
    catDrugs: 'Drugs',
    catViolence: 'Violence or extremism',
    catHate: 'Hate speech',
    catPolitics: 'Politics',
    catThirdPartyPromo: 'Third-party promotion',
    catPersonalData: 'Personal data',
    catManipulation: 'Review manipulation',
    catProviderSafety: 'Blocked by AI safety filter',
    catExternalImage: 'Image isn’t uploaded to OA Studio',
    catImageUnavailable: 'Image unavailable',
    resubmitHint: 'Fix the issues and choose access below to submit again',
    retryHint: 'Choose access below to submit again',
    updateResubmitHint: 'Fix the issues and submit the update again',
    rejectedTitle: 'Didn’t pass review',
    updateRejectedTitle: 'The update didn’t pass review',
    articleSaveRefused: 'The article is under review — your changes weren’t saved',
    courseSaveRefused: 'The course is under review — your changes weren’t saved',
    articleTranslateRefused: 'The article is under review — translation isn’t available',
    fieldName: 'Name',
    fieldDescription: 'Description',
    fieldText: 'Text',
    fieldTitle: 'Title',
    fieldQuestion: 'Question',
    fieldLink: 'Link',
    fieldContent: 'Content',
    fieldAnswer: 'Answer',
    fieldExplanation: 'Explanation',
    fieldBanner: 'Banner',
    fieldStyleReferences: 'Style references',
    partOption: 'Answer option',
    partPair: 'Pair',
    partButton: 'Button',
    partElement: 'Element',
    partTable: 'Table cell',
    partBadge: 'Badge',
    updateFailed: 'Couldn’t submit the update',
    noChanges: 'No changes to submit',
    waitForRun: (run: string) => `Wait for the run to finish: ${run}`,
    accessFailed: 'Couldn’t change access',
    catalogNotAllowed: 'Publishing to the catalog isn’t available to you',
    requestWithdrawn: 'Review request withdrawn',
    draftDiscarded: 'Changes discarded',
    draftDiscardFailed: 'Couldn’t discard changes',
  },
})
